import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import feature1 from '../../assets/img/features-1.svg';
import feature2 from '../../assets/img/features-2.svg';
import feature3 from '../../assets/img/features-3.svg';
import feature4 from '../../assets/img/features-4.svg';
import feature5 from '../../assets/img/features-5.svg';
import feature6 from '../../assets/img/features-6.svg';
import feature7 from '../../assets/img/features-7.svg';
import feature8 from '../../assets/img/features-8.svg';
import resfeature1 from '../../assets/img/res-features-1.svg';
import resfeature2 from '../../assets/img/res-features-2.svg';
import resfeature3 from '../../assets/img/res-features-3.svg';
import resfeature4 from '../../assets/img/res-features-4.svg';
import resfeature5 from '../../assets/img/res-features-5.svg';
import resfeature6 from '../../assets/img/res-features-6.svg';
import resfeature7 from '../../assets/img/res-features-7.svg';
import resfeature8 from '../../assets/img/res-features-8.svg';
import vpsfeature1 from '../../assets/img/vps-features-1.svg';
import vpsfeature2 from '../../assets/img/vps-features-2.svg';
import vpsfeature3 from '../../assets/img/vps-features-3.svg';
import vpsfeature4 from '../../assets/img/vps-features-4.svg';
import vpsfeature5 from '../../assets/img/vps-features-5.svg';
import vpsfeature6 from '../../assets/img/vps-features-6.svg';
import vpsfeature7 from '../../assets/img/vps-features-7.svg';
import vpsfeature8 from '../../assets/img/vps-features-8.svg';
import './featuresWidget.scss';

function FeaturesWidget({ dataType }) {
    const { t } = useTranslation();
    const splitIndex = 4;

    let featuresData = [
        {
            title: t('web-hosting-page.features-column.title-1'),
            text: t('web-hosting-page.features-column.text-1'),
            image: feature1,
            isFree: true
        },
        {
            title: t('web-hosting-page.features-column.title-2'),
            text: t('web-hosting-page.features-column.text-2'),
            image: feature2
        },
        {
            title: t('web-hosting-page.features-column.title-3'),
            text: t('web-hosting-page.features-column.text-3'),
            image: feature3
        },
        {
            title: t('web-hosting-page.features-column.title-4'),
            text: t('web-hosting-page.features-column.text-4'),
            image: feature4
        },
        {
            title: t('web-hosting-page.features-column.title-5'),
            text: t('web-hosting-page.features-column.text-5'),
            image: feature5,
            isFree: true
        },
        {
            title: t('web-hosting-page.features-column.title-6'),
            text: t('web-hosting-page.features-column.text-6'),
            image: feature6
        },
        {
            title: t('web-hosting-page.features-column.title-7'),
            text: t('web-hosting-page.features-column.text-7'),
            image: feature7,
            isCloud: true
        },
        {
            title: t('web-hosting-page.features-column.title-8'),
            text: t('web-hosting-page.features-column.text-8'),
            image: feature8
        }
    ];

    const resellerData = [
        {
            title: t('reseller-hosting-page.features-column.title-1'),
            text: t('reseller-hosting-page.features-column.text-1'),
            image: resfeature1,
            isFree: true
        },
        {
            title: t('reseller-hosting-page.features-column.title-2'),
            text: t('reseller-hosting-page.features-column.text-2'),
            image: resfeature2
        },
        {
            title: t('reseller-hosting-page.features-column.title-3'),
            text: t('reseller-hosting-page.features-column.text-3'),
            image: resfeature3
        },
        {
            title: t('reseller-hosting-page.features-column.title-4'),
            text: t('reseller-hosting-page.features-column.text-4'),
            image: resfeature4
        },
        {
            title: t('reseller-hosting-page.features-column.title-5'),
            text: t('reseller-hosting-page.features-column.text-5'),
            image: resfeature5
        },
        {
            title: t('reseller-hosting-page.features-column.title-6'),
            text: t('reseller-hosting-page.features-column.text-6'),
            image: resfeature6
        },
        {
            title: t('reseller-hosting-page.features-column.title-7'),
            text: t('reseller-hosting-page.features-column.text-7'),
            image: resfeature7
        },
        {
            title: t('reseller-hosting-page.features-column.title-8'),
            text: t('reseller-hosting-page.features-column.text-8'),
            image: resfeature8
        }
    ];

    const vpsData = [
        {
            title: t('vps-page.features-column.title-1'),
            text: t('vps-page.features-column.text-1'),
            image: vpsfeature1
        },
        {
            title: t('vps-page.features-column.title-2'),
            text: t('vps-page.features-column.text-2'),
            image: vpsfeature2
        },
        {
            title: t('vps-page.features-column.title-3'),
            text: t('vps-page.features-column.text-3'),
            image: vpsfeature3
        },
        {
            title: t('vps-page.features-column.title-4'),
            text: t('vps-page.features-column.text-4'),
            image: vpsfeature4
        },
        {
            title: t('vps-page.features-column.title-5'),
            text: t('vps-page.features-column.text-5'),
            image: vpsfeature5
        },
        {
            title: t('vps-page.features-column.title-6'),
            text: t('vps-page.features-column.text-6'),
            image: vpsfeature6
        },
        {
            title: t('vps-page.features-column.title-7'),
            text: t('vps-page.features-column.text-7'),
            image: vpsfeature7
        },
        {
            title: t('vps-page.features-column.title-8'),
            text: t('vps-page.features-column.text-8'),
            image: vpsfeature8
        }
    ];

    if (dataType === 'reseller') {
        featuresData = resellerData;
    } else if (dataType === 'vps') {
        featuresData = vpsData;
    }

    const column1Data = featuresData.slice(0, splitIndex);
    const column2Data = featuresData.slice(splitIndex);

    const renderFeatureItem = (feature, index) => (
        <div className="single-feature" key={`${feature.title}-${index}`}>
            <Row>
                <Col md={3}>
                    <img className="feature-image" src={feature.image} alt={feature.title} />
                </Col>
                <Col md={9}>
                    <h3 className="feature-title">
                        {feature.title}
                        {feature.isFree && (
                            <span className="feature-free">
                                {t('web-hosting-page.features-column.free')}
                            </span>
                        )}
                        {feature.isCloud && <span className="feature-cloud">CloudPro</span>}
                    </h3>
                    <p className="feature-text">{feature.text}</p>
                </Col>
            </Row>
        </div>
    );

    return (
        <div className="features-columns-wrapper">
            <Row>
                <Col md={6} xs={12}>
                    {column1Data.map(renderFeatureItem)}
                </Col>
                <Col md={6} xs={12}>
                    {column2Data.map(renderFeatureItem)}
                </Col>
            </Row>
        </div>
    );
}

FeaturesWidget.propTypes = {
    dataType: PropTypes.string
};

FeaturesWidget.defaultProps = {
    dataType: 'web'
};

export default FeaturesWidget;
